import Glide from '@glidejs/glide'
//import { updateFadeSlider } from './slider-utils';


const initReviewsBlock = () => {
    let block = document.querySelector(".js-block-reviews");

    if (!block) return;
    let gliderRoot = block.querySelector(".glide");
    if (!gliderRoot) return;


    const faces = block.querySelectorAll(".js-face")
    const texts = block.querySelectorAll(".js-text")
    const buttons = block.querySelectorAll(".js-goToButton");



    const updateFaces = (desiredState) => {
        if (!faces) return;
        if (faces.length < 1) return;
        faces.forEach((element, index) => {
            if (index === desiredState) {
                element.animate({ opacity: 1 }, { duration: 500 }).onfinish = () => {
                    element.classList.remove("opacity-0");
                };
            } else {
                element.animate({ opacity: 0 }, { duration: 500 }).onfinish = () => {
                    element.classList.add("opacity-0");
                };
            }
        });
    }

    const updateButtons = (desiredState) => {
        if (!buttons) return;
        if (buttons < 1) return;
        buttons.forEach((element, index) => {
            if (index === desiredState) {
                element.classList.add("is-active");

            } else {
                element.classList.remove("is-active");
            }
        });
    }

    const updateTexts = (desiredState) => {
        if (!texts) return;
        if (texts.length < 1) return;
        texts.forEach((element, index) => {
            if (index === desiredState) {
                element.animate({ opacity: 1 }, { duration: 300 }).onfinish = () => {
                    element.classList.remove("opacity-0");
                    element.classList.add("z-10");
                };
            } else {
                if (element.classList.contains("opacity-0")) return;
                element.animate({ opacity: 0 }, { duration: 500 }).onfinish = () => {
                    element.classList.add("opacity-0");
                    element.classList.remove("z-10");
                };
            }
        });
    }

    let options = {
        type: 'carousel',
        perView: 1,
        autoplay: 0,
        animationDuration: 1200,
        swipeThreshold: 40, //default 80, which is a bit too lazy
        dragThreshold: 60, //default 120, which is a bit too lazy
        touchAngle: 30,
        gap: 80,
        breakpoints: {
            1024: {
                gap: 10
            },

        }
    }

    const glide = new Glide(gliderRoot, options);



    //console.log(buttons);
    buttons.forEach((element, i) => {
        element.addEventListener("click", () => {
            //console.log(i);
            glide.go('=' + i);
        })
    });


    glide.on('mount.after', function () {
        gliderRoot.classList.add('mounted')
    })

    glide.on('run', (event) => {

        //console.log(event);
        //console.log(glide.index);
        //updateNumbers(glide.index);
        //updateBar(glide.index);
        updateFaces(glide.index);
        updateTexts(glide.index);
        updateButtons(glide.index);

    })

    glide.mount()

}

export { initReviewsBlock }
